import type { LoadOptions } from "../shared/api-contract";

/**
 * Load options for a Vault model, with v65's `embeddedScene` decided.
 *
 * A "Ring + scene" file carries its own whole scene. A page that is about to
 * apply a scene the Vault SAVED for this model (`config.vjson`, or a shared
 * link's) passes "ignore" — the saved one is newer, and applying both would
 * only flash the file's look first. Without a saved scene the file's own look
 * IS the scene: "apply".
 *
 * `sceneFiles` is caps `sceneFileV65`: an older viewer is sent exactly the
 * options it was sent before (no extra field, `undefined` stays `undefined`).
 */
export function withEmbeddedScene(base: LoadOptions | undefined, sceneFiles: boolean, savedScene: boolean): LoadOptions | undefined {
  if (!sceneFiles) return base;
  return { ...base, embeddedScene: savedScene ? "ignore" : "apply" };
}
